<template>
  <div class="ActivityMaintenanceInformation">
    <el-collapse v-model="collapseNumber">
      <el-collapse-item class="collapseItem" title="活动计划信息" name="default">
        <el-form ref="form" class="form UniformCss" label-width="110px" label-position="right">
          <el-row>
            
            <!-- <el-col :span="6">
              <el-form-item label="活动计划编码" class="act-item">
                <el-input v-model="data.planCode" disabled />
              </el-form-item>   lr0025
            </el-col> -->
        <!-- lr0051 -->
             <el-col :span="6">
              <el-form-item label="活动计划编码" class="act-item">
                <a-input v-model="data.planCode" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="活动名称" class="act-item">
                <el-tooltip class="item" effect="dark" :content="data.actName" placement="top">
                  <a-input v-model="data.actName" disabled />
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生效时间" class="act-item">
                <a-date-picker :value-format="'YYYY-MM-DD HH:mm:ss'" v-model="data.planStartTime" type="date" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="失效时间" class="act-item">
                <a-date-picker :value-format="'YYYY-MM-DD HH:mm:ss'" v-model="data.planEndTime" type="date" disabled />
              </el-form-item>
            </el-col>
            <el-row>
            <el-col :span="12">
              <el-form-item label="市场活动来源" class="act-item">
                <a-input v-model="selectedOrgText" disabled />
              </el-form-item>
            </el-col>
              <el-col :span="6">
                <el-form-item label="费用额度(元)" class="act-item">
                  <a-input v-model="formattedFeeLimit" disabled />
                </el-form-item>
            </el-col>
              <el-col :span="6">
                <el-form-item label="核销比例(%)" class="act-item">
                  <a-input v-model="data.writeRate" disabled />
                </el-form-item>
              </el-col>
            </el-row>
          </el-row>
            <!-- <el-col :span="6">
              <el-form-item label="发布时间" class="act-item">
                <el-input v-model="data.releaseTime" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="预算类型" class="act-item">
                <el-input v-model="data.budgetTypeName" disabled />
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="6">
              <el-form-item label="类型" class="act-item">
                <el-input :value="data.type == 0 ? '大区' : '总部'" disabled />
              </el-form-item>
            </el-col> -->
          <!-- </el-row>
          <el-row> -->
            <!-- <el-col :span="6">
              <el-form-item label="一级来源" class="act-item">
                <el-input v-model="data.oneLevelName" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="二级来源" class="act-item">
                <el-input v-model="data.twoLevelName" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="三级来源" class="act-item">
                <el-input v-model="data.threeLevelName" disabled />
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="6">
              <el-form-item label="四级来源" class="act-item">
                <el-input v-model="data.fourLevelName" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="五级来源" class="act-item">
                <el-input v-model="data.fiveLevelName" disabled />
              </el-form-item>
            </el-col> -->
          <!-- </el-row> 
          <el-row>
            <el-col v-if="data.strainsCarName" :span="12">
              <el-form-item label="执行车系" class="act-item">
                <el-tooltip class="item" effect="dark" content="点击查看" placement="top-start">
                  <el-input v-model="data.strainsCarName" readonly @click.native="onShowCarSeries" />
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col v-else :span="12">
              <el-form-item label="执行车系" class="act-item">
                <el-input v-model="emptyText" disabled />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row> -->
            <!-- <el-col :span="6">
              <el-form-item label="经销商" class="act-item">
                <el-input v-model="data.dealerName" disabled />
              </el-form-item>
            </el-col> -->
            <el-row>
            <el-col :span="6">
              <el-form-item label="执行频次" class="act-item">
                <a-input v-model="data.executeFreq" disabled />
              </el-form-item>
            </el-col>
          </el-row>

            <!-- <el-col :span="6">
              <el-form-item label="集客目标" class="act-item">
                <el-input v-model="data.customerTarget" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="订单目标" class="act-item">
                <el-input v-model="data.orderTarget" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="执行数量" class="act-item">
                <el-input v-model="data.executeNum" disabled />
              </el-form-item>
            </el-col> -->
          <el-row>
            <el-col :span="12" style="height: auto">
              <el-form-item label="其他说明" class="width100Px">
                <a-input v-model="data.remarks" :autosize="{ minRows: 2, maxRows: 6}" style="width: 100%" disabled type="textarea" />
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: auto">
              <el-form-item label="核销规则" class="width100Px">
                <a-input v-model="data.writeOffRules" :autosize="{ minRows: 2, maxRows: 6}" style="width: 100%" disabled type="textarea" />
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: auto">
              <el-form-item label="核销材料说明" class="width100Px">
                <a-input v-model="data.writeOffMaterial" :autosize="{ minRows: 2, maxRows: 6}" style="width: 100%" disabled type="textarea" />
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: auto">
              <el-form-item label="核销其他说明" class="width100Px">
                <a-input v-model="data.writeOffOther" :autosize="{ minRows: 2, maxRows: 6}" style="width: 100%" disabled type="textarea" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="执行车系" :visible.sync="showCarSeries" width="40%">
      <vxe-table
        ref="xTable"
        border
        class="mytable-scrollbar"
        show-header-overflow
        show-overflow
        :column-config="{ resizable: true }"
        stripe
        round
        style="margin-top: 10px"
        :max-height="$store.state.app.height - 350 < 185 ? 185 : $store.state.app.height - 350"
        :scroll-y="{ enabled: false }"
        :row-config="{ isHover: true }"
        :data="carStrainList"
      >
        <vxe-column type="seq" title="序号" width="60" align="center" />
        <vxe-column title="品系" field="strains" align="center" />
        <vxe-column title="车系" field="carSeries" align="center" />
      </vxe-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCarSeries = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { toThousandNumFilter } from '@/filters/index.js'
export default {
  name: 'ActivityMaintenanceInformation',
  props: ['data'],
  data() {
    return {
      collapseNumber: 'default',
      emptyText: '无',
      carStrainList: [],
      showCarSeries: false
    }
  },
  computed: {
    formattedFeeLimit() {
      return toThousandNumFilter(this.data.feeLimit)
    },
    selectedOrgText() {
      return this.data.oneLevelName + '/' + this.data.twoLevelName + '/' + this.data.threeLevelName
    }
  },
  methods: {
    onShowCarSeries() {
      // 使用逗号分割字符串
      const stringArray = this.data.strainsCarName.split(',')
      // 创建一个数组来存放对象
      const objectArray = []
      // 遍历分割后的字符串数组，并将每个元素转换为对象
      stringArray.forEach(function(item) {
        var parts = item.split('-') // 使用短横线分割每个元素
        if (parts.length === 2) {
          var obj = {
            strains: parts[0],
            carSeries: parts[1]
          }
          objectArray.push(obj)
        }
      })
      this.carStrainList = objectArray
      this.showCarSeries = true
    }
  }
}
// lr0025
</script>
<style lang="less">
.ActivityMaintenanceInformation {
  margin-bottom: 0px;
  font-size: 16px;
  border: 1px solid #cccccc;
  border-top: none;
  p {
    background: #0a76a4;
    color: white;
    padding: 6px 20px;
    margin: 0 0 20px;
  }
  .inputH {
    .el-input__inner {
      height: 60px;
    }
  }
  .form {
    .formBox {
      span {
        font-size: 12px;
      }
    }
    // .formLine {
    //   float: left;
    //   width: 100%;
    //   margin: 0;
    // }
  }
  .el-form-item--medium {
    margin: 0 0 10px 0;
  }
  .formItem {
    span {
      display: inline-block;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 12px;
    }
  }
  .collapseItem {
    .el-collapse-item__header {
      padding: 0px 20px;
      width: 100%;
      margin: 0;
      background: #0a76a4;
      color: #ffffff;
      height: 30px;
      line-height: 30px;
      font-size: 16px;
    }
    .el-collapse-item__content {
      padding-top: 20px;
      padding-right: 20px;
    }
  }

 .el-input__inner {
  height: 30px!important;
  }
  
}
</style>
